import { render, staticRenderFns } from "./PcInfo.vue?vue&type=template&id=05f2399e&scoped=true"
import script from "./PcInfo.vue?vue&type=script&lang=js"
export * from "./PcInfo.vue?vue&type=script&lang=js"
import style0 from "./PcInfo.vue?vue&type=style&index=0&id=05f2399e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2399e",
  null
  
)

export default component.exports